export const UPDATE_SESSION_TIMESTAMP = 'UPDATE_SESSION_TIMESTAMP';
export const updateSessionTimestamp = () => {
  return {
    type: UPDATE_SESSION_TIMESTAMP
  };
};